import { useSelectedStudentIdContext } from "#/components/exam-results/context/studentsList/context";
import Infographic from "#/components/exam-results/infographic";
import { getSingleStudentExamResult } from "#/services/rest/gwt/exam-results/views/type-2/single-user.api";
import { useParams } from "@monta/router-react";
import { forwardRef, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import MultiLesson from "./MultiLesson";
import styles from "./styles.module.scss";

export type Topic = "book" | "topic";

const OverallInfoTab = forwardRef<HTMLDivElement, object>((_, contentRef) => {
  const params = useParams();
  const { selectedStudentId } = useSelectedStudentIdContext();
  const examTakingId = Number(params["examTakingId"]);
  const queryClient = useQueryClient();
  const [category, setCategory] = useState<Topic>("book");
  const [isSingleLesson, setIsSingleLesson] = useState(true);

  const { data, mutate } = getSingleStudentExamResult.useMutation({
    onSuccess: (res) => {
      if (res.length !== 1) setIsSingleLesson(false);
    }
  });

  useEffect(() => {
    if (selectedStudentId && selectedStudentId > 0)
      mutate({
        body: {
          examTakingDetailId: examTakingId,
          studentId: selectedStudentId,
          resultTypeId: category === "book" ? 20 : 30
        }
      });
  }, [category, examTakingId, mutate, selectedStudentId]);

  const reqHandler = () => {
    setCategory((prev) => {
      if (prev === "book") return "topic";
      return "book";
    });
  };

  useEffect(() => {
    queryClient.invalidateQueries(getSingleStudentExamResult.key());
  }, [category]);

  return (
    <div ref={contentRef} className={styles["print"]}>
      {data &&
        (isSingleLesson ? (
          <Infographic
            finalMark={data[0].mark}
            correctCount={data[0].correctNo}
            wrongCount={data[0].incorrectNo}
            uncheckedCount={data[0].noAnswerNo}
            totalCount={data[0].totalQuestionNo}
            examName={data[0].examName}
            date={data[0].startDatetime}
          />
        ) : (
          <MultiLesson
            onDataTypeChange={reqHandler}
            data={data ?? []}
            participantNo={1}
            dataType={category}
          />
        ))}
    </div>
  );
});

OverallInfoTab.displayName = "GeneralInfo";

export default OverallInfoTab;
